




































import Vue from 'vue';
import { mapMutations, mapState } from 'vuex';

export default Vue.extend({
    computed: {
        ...mapState(['applicationMessage']),
        showApplicationMessage: {
            get() {
                return this.applicationMessage !== null;
            },
            set(newValue: boolean) {
                if (!newValue) {
                    this.clearApplicationMessage();
                }
            },
        },
    },
    methods: {
        ...mapMutations(['clearApplicationMessage']),
    },
});
